<div class="flex-layout fx-layout-column fx-align-start">
  <div class="p-4 identity-tab">

    <div class="identity-provider">
      <span class="identity-provider__label">Identity provider:</span>
      <span class="identity-provider__pill" [class.identity-provider__pill--external]="isLegacyIdentityActionMismatch">
        {{ currentIdentityProviderDisplay }}
      </span>
    </div>

    @if (routesPasswordToAuth0) {
    <div class="provider-notice" role="status">
      <p class="provider-notice__title">This user is on {{ currentIdentityProviderDisplay }}.</p>
      <p class="m-0">
        Passwords and security questions are no longer managed here. To help this user reset their
        password, send them a reset link to the email on their account.
      </p>
    </div>

    <div class="reset-link">
      <button
        class="reset-link__button"
        mat-raised-button color="primary"
        type="button"
        [disabled]="isViewOnly || isLoading"
        (click)="sendAuth0PasswordReset()">
        Send Password Reset Link
      </button>
    </div>

    <div class="provider-tip">
      <p class="provider-tip__lead">
        <strong>User can’t access their email?</strong> Don’t change it based on the caller’s info
        alone. Confirm it’s them through the company phone number on file first.
      </p>
      <ol class="provider-tip__steps">
        <li>
          <strong>Check the number they’re calling from.</strong> If it matches the company phone number
          on file, update their email on the <strong>Details</strong> tab, note how you confirmed it, then
          come back here and send the reset link.
        </li>
        <li>
          <strong>If it doesn’t match, call them back.</strong> Call the company phone number on file (not
          a number the caller gives you). If the user answers, update their email on the
          <strong>Details</strong> tab, note how you confirmed it, then come back here and send the reset link.
        </li>
        <li>
          <strong>If you can’t confirm it’s them, don’t change the email.</strong> Check their role instead:
          <ul class="provider-tip__cases">
            <li>
              <strong>Business User or Business Location Admin:</strong> Ask the company’s Business Admin
              to invite them again with their new email. Once the invite is accepted, submit a Samanage
              ticket to delete this account.
            </li>
            <li>
              <strong>Business Admin, and the company has another Business Admin:</strong> Ask the other
              Business Admin to invite them again with their new email. Once the invite is accepted,
              submit a Samanage ticket to delete this account.
            </li>
            <li>
              <strong>Business Admin, and they’re the only Business Admin:</strong> Don’t change the email.
              Ask them to call back from the company phone, or to be available at that number for a
              callback.
            </li>
          </ul>
        </li>
      </ol>
    </div>
    }

    <!--
      Setting a password only changes the legacy Zing identity, which a person who signs in
      elsewhere no longer uses, so the section is hidden for them rather than left disabled.
    -->
    @if (!isLegacyIdentityActionMismatch) {
    <app-person-update-password
      [generatedPassword]="generatedPassword"
      [userHasEmail] = "userHasEmail"
      [updateBlocked]="isLegacyIdentityActionMismatch"
      (generatePasswordEvent)="generatePassword()"
      (updatePasswordEvent)="updatePassword($event)"> </app-person-update-password>
    }

    <!--
      The security-question actions retire rather than move to Auth0 (JXP-1911): Auth0 has no
      security-question feature, so there is nothing for them to act on once a person signs in
      elsewhere. Hidden rather than deleted because Zing-resident people still use them, and
      hiding the child is required, not cosmetic: it renders its own heading and an enabled
      submit button even before a form exists.
    -->
    @if (!isLegacyIdentityActionMismatch) {
    <mat-divider class="my-3"></mat-divider>

    <app-person-update-security-question
      [securityQuestions]="securityQuestions"
      [usersSecurityQuestions]="usersSecurityQuestions"
      (changeSecurityQuestionsEvent)="changeSecurityQuestions($event)">
     </app-person-update-security-question>
    }

  </div>
</div>

<app-in-progress [loading]="isLoading"> </app-in-progress>